import {
  computed,
  Injectable,
  resource,
  ResourceLoaderParams,
  ResourceRef,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import {
  BicString,
  CreditInstituteString,
  IbanString,
  IInstitutionData,
} from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { firstValueFrom } from 'rxjs';
import { PaymentInstituteDataGateway } from './payment-institute-data.gateway';

@Injectable({
  providedIn: 'root',
})
export class PaymentInstituteDataStore {
  private readonly gateway: PaymentInstituteDataGateway =
    new PaymentInstituteDataGateway();
  private readonly instituteDataRequest: WritableSignal<IbanString> =
    signal<IbanString>('' as IbanString);

  #instituteDataResource: ResourceRef<
    IApiResponse<IInstitutionData> | undefined
  > = resource({
    params: this.instituteDataRequest,
    loader: ({
      params,
    }: ResourceLoaderParams<IbanString>): Promise<
      IApiResponse<IInstitutionData> | undefined
    > => {
      return params
        ? firstValueFrom(this.gateway.get(params))
        : Promise.resolve(undefined);
    },
  });

  public readonly isLoading: Signal<boolean> = computed((): boolean =>
    this.#instituteDataResource.isLoading()
  );

  public readonly instituteData: Signal<IInstitutionData> = computed(
    (): IInstitutionData =>
      this.#instituteDataResource.value()?.data ?? {
        bic: '' as BicString,
        creditInstitute: '' as CreditInstituteString,
      }
  );

  public loadInstituteData(iban: IbanString): void {
    this.instituteDataRequest.set(iban);
  }

  public reload(): void {
    this.instituteDataRequest.set('' as IbanString);
  }
}
